import FooterLogosImage from "app/images/logos/footerLogos.png";
import React from "react";

const FooterLogos = (props: {
  gamcare: (...args: Array<any>) => any;
  gamblingcontrol: (...args: Array<any>) => any;
}): React.JSX.Element => {
  const { gamcare, gamblingcontrol } = props;
  return (
    <div className="logos">
      <img src={FooterLogosImage} alt="logos" />
      <span className="gamcare" onClick={gamcare}></span>
      <span className="gamblingcontrol" onClick={gamblingcontrol}></span>
      <div></div>
    </div>
  );
};

export default FooterLogos;
